/*********************************************************************************************************************************
 This class has been automatically generated using KLTT-APIRestGenerator project, don't do manual file modifications.
 Mon Oct 22 12:45:25 CEST 2018

 "Licensed to the Apache Software Foundation (ASF) under one or more contributor license agreements;
  and to You under the Apache License, Version 2.0. "
**********************************************************************************************************************************/

/**
 * This class contains the common enumerations for schemes
 */
export class SchemesValues
{
    /** Schema type - http */
	static http  = "http" ;
	/** Schema type - https */
	static https = "https" ;
	/** Schema type - ws */
	static ws    = "ws" ;
	/** Schema type - wss */
	static wss   = "wss" ;
}